var $subNavToggle = $('#subNavTrigger');
var subNavInitialized = false;

$subNavToggle.on('click', function () {

  if (subNavInitialized === true) {

    $('#subNavItems').removeClass('subnav-open');

    // setTimeout(function () {
    //   $subNavToggle.removeClass('toggled');
    //   //$('#overlay').remove();
    // }, 50);

    subNavInitialized = false;

  } else {

    $('#subNavItems').addClass('subnav-open');

    // setTimeout(function () {
    //   $subNavToggle.addClass('toggled');
    // }, 50);

    subNavInitialized = true;

  }
});
